import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { QuotingToolService } from "../../quoting-tool.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { DomSanitizer } from '@angular/platform-browser';

let canvas = document.createElement('canvas');
let context = canvas.getContext('2d');

interface PcbDesign {
  pngDataUrl?: string; // pngDataUrl is optional
  fileName: string;
  // Add other properties if necessary
}
interface MechanicalDesigns {
  pngDataUrl?: string; // pngDataUrl is optional
  fileName: string;
  // Add other properties if necessary
}
interface MechanicalDrillDesigns {
  pngDataUrl?: string; // pngDataUrl is optional
  fileName: string;
  // Add other properties if necessary
}
@Component({
  selector: "app-design-view",
  templateUrl: "./design-view.component.html"
})
export class DesignViewComponent implements OnInit {

  @Output() nextStep = new EventEmitter<void>();
  @ViewChild('pcbCircuitMain') pcbCircuitMain!: ElementRef;

  getImagePath: any = environment.image_path;
  selectedTabIndex: number = 0;
  @ViewChild("fileInput") fileInput: any;
  selectedFileName: string = "";

  projectType: any;
  projectID: any;
  isFetchingRFCDetails = true;
  isHovered: boolean = false;

  uploadGerberFlag: boolean = false;


  OnNextStep(){
    this.nextStep.emit();
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFileName = file.name;
    } else {
      this.selectedFileName = "No file selected";
    }
  }

  tabChanged(event: any) {
    this.selectedTabIndex = event.index;
    localStorage.setItem("currentTab", event.index)
  }

  constructor(private quotingService: QuotingToolService, private notificationService: NotificationService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.projectID = localStorage.getItem('projectID');
    
  }

  ngAfterViewInit(){
    this.projectType = localStorage.getItem('projectType');
    let uploadFlagValue = localStorage.getItem('upload_gerber');

    if (this.projectType === '1') {
      this.selectedTabIndex = 0;
    } else if (this.projectType === '2') {
      this.selectedTabIndex = 1;
    } else if (this.projectType === '3') {
      this.selectedTabIndex = 0;
    }
    if (uploadFlagValue == 'true' ) {
      this.uploadGerberFlag = true;
      this.LoadDesignView();
    }
  }

  extractLabel(fileName: string): string {
    // Split the filename by '.' and take the first part
    const parts = fileName.split('.');

    if (parts.length > 1) {
      // Split the first part by '-' and capitalize each word
      return parts[0].split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') + ' ' + parts[1];
    } else {
      // If there is no '.' in the filename, split by '-' and capitalize each word
      return fileName.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
  }


  dpi: number = 96;
  mmToPx(mm: number): number {
    if (mm) {
      return mm * (this.dpi / 25.4);
    } else {
      return 150
    }

  }

  bypassSecurityTrustHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  pcbDesigns: PcbDesign[] = [];
  mechanicalDesigns: MechanicalDesigns[] = [];
  mechanicalDrillDesigns: MechanicalDrillDesigns[] = [];
  selectedGerberImage: any;
  defaultGerberImage: any;
  isConvertingSVG: boolean = false;
  LoadDesignView() {
    this.isConvertingSVG = false;
    this.isFetchingRFCDetails = true;
    this.quotingService.GetProjectByGerberFiles(this.projectID).subscribe(async (resJSON: any) => {
      if (resJSON.code == 200) {
        let tempSVGArray = resJSON.data;

        this.defaultGerberImage = this.pcbDesigns?.[0];


        this.notificationService.showSuccess(`${resJSON.message}`, "");
        this.isFetchingRFCDetails = false;

        // Convert each SVG to PNG
        if (tempSVGArray && tempSVGArray.length > 0) {
          this.isConvertingSVG = true;
          for (let item of tempSVGArray) {
            item.pngDataUrl = await this.convertSVGtoPNG(item.content);
          }
        }

        // Assuming you want to separate files with 'mechanical' in their filename and the ones without
        const otherFiles = tempSVGArray?.filter((item: any) => (!item?.fileName?.toLowerCase().includes('mechanical') && !item?.fileName?.toLowerCase().includes('drill')));
        this.pcbDesigns = otherFiles;
        this.selectedGerberImage = await this.convertSVGtoPNG(otherFiles?.[0]?.content);
        this.defaultGerberImage = this.selectedGerberImage

        // Assuming your original array is named 'data'
        this.mechanicalDesigns = tempSVGArray?.filter((item: any) => (item?.fileName?.toLowerCase().includes('mechanical') && !item?.fileName?.toLowerCase().includes('drill')));

        // Assuming your original array is named 'data'
        this.mechanicalDrillDesigns = tempSVGArray?.filter((item: any) => (item?.fileName?.toLowerCase().includes('mechanical') && item?.fileName?.toLowerCase().includes('drill')));
        this.isConvertingSVG = false;
      } else {
        this.notificationService.showError(`${resJSON.message}`, "");
        this.isFetchingRFCDetails = false;
        this.isConvertingSVG = false;
      }
    })
  }

  async convertSVGtoPNG(svgContent: string): Promise<string> {
    // Create a new Image element
    const img = new Image();

    // Create a Promise to handle image loading
    const promise = new Promise<string>((resolve, reject) => {
      img.onload = () => {
        // Create a canvas element
        // const canvas = document.createElement('canvas');
        // const context = canvas.getContext('2d');


        // Desired display size in CSS pixels
        const displayWidth = 500;
        const displayHeight = 500;

        // Desired resolution multiplier
        // const resolutionMultiplier = 5;
        const resolutionMultiplier = (window.devicePixelRatio + 10) || 5;

        // Set the size of the canvas drawing buffer
        canvas.width = displayWidth * resolutionMultiplier;
        canvas.height = displayHeight * resolutionMultiplier;

        // Scale the context to match the desired resolution
        context!.scale(resolutionMultiplier, resolutionMultiplier);

        // Optional: Set the CSS width and height to match the desired size on the page
        canvas.style.width = `${displayWidth}px`;
        canvas.style.height = `${displayHeight}px`;


        // Set canvas dimensions
        // canvas.width = img.width ;
        // canvas.height = img.height;

        // Draw the SVG image onto the canvas
        context!.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);


        // Convert canvas to data URL
        const dataUrl = canvas.toDataURL('image/png');


        // Resolve the Promise with the data URL
        resolve(dataUrl);
      };

      // Handle image loading errors
      img.onerror = (error) => {
        reject(error);
      };
    });

    // Set the image source to the SVG content
    img.src = 'data:image/svg+xml,' + encodeURIComponent(svgContent);

    // Return the Promise
    return promise;
  }
  onMouseEnter(item: any) {
    this.selectedGerberImage = item.pngDataUrl;
    this.isHovered = true;
  }

  scale = 1;
  isDragging = false;
  startX = 0;
  startY = 0;
  offsetX = 0;
  offsetY = 0;
  lastOffsetX = 0; // Stores the last offset X
  lastOffsetY = 0; // Stores the last offset Y


  zoom(direction: 'in' | 'out') {
    if (direction === 'in') {
      this.scale += 0.1;
    } else {
      this.scale -= 0.1;
      if (this.scale < 1) this.scale = 1; // Prevent scaling below the original size
    }
    this.updateImageTransform();
  }

  updateImageTransform() {
    const image = this.pcbCircuitMain.nativeElement as HTMLElement;
    image.style.transform = `scale(${this.scale}) translate(${this.offsetX}px, ${this.offsetY}px)`;
  }

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.clientX; // Record initial mouse position
    this.startY = event.clientY;
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;

    // Calculate the current offsets based on mouse movement
    this.offsetX = this.lastOffsetX + (event.clientX - this.startX);
    this.offsetY = this.lastOffsetY + (event.clientY - this.startY);

    this.updateImageTransform();
  }

  onMouseUp() {
    this.isDragging = false;

    // Save the current offset for the next drag session
    this.lastOffsetX = this.offsetX;
    this.lastOffsetY = this.offsetY;
  }

  onMouseLeave() {
    this.isDragging = false;
  }

  resetZoom() {
    // Reset scale and position
    this.scale = 1;
    this.offsetX = 0;
    this.offsetY = 0;
    this.lastOffsetX = 0;
    this.lastOffsetY = 0;
  
    // Apply the reset transform
    this.updateImageTransform();
  }

  onImageClick(item: any) {
    this.selectedGerberImage = item.pngDataUrl;

    this.scale = 1; // Reset scale to original size
  this.offsetX = 0;
  this.offsetY = 0;
  this.lastOffsetX = 0;
  this.lastOffsetY = 0;

  // Apply the reset transform
  this.updateImageTransform();
  }
}
